import { render, staticRenderFns } from "./AddCampo.vue?vue&type=template&id=520b0219"
import script from "./AddCampo.vue?vue&type=script&lang=js"
export * from "./AddCampo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports